export type UUID = string;
// export type UUID = `${string}-${string}-${string}-${string}-${string}`;

export const UUID_NULL: UUID = '00000000-0000-0000-0000-000000000000';
